import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { LoginFormSchema } from "../schemas";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../components/ui/Form";
import { Input } from "../components/ui/Input";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Link } from "react-router-dom";
import { z } from "zod";
import { useAuth } from "../hooks/useAuth";
import { Checkbox } from "../components/ui/Checkbox";
import { Label } from "../components/ui/Label";
import { useEffect } from "react";

function Login() {
  const { login, persist, setPersist } = useAuth();

  const form = useForm({
    resolver: zodResolver(LoginFormSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = async (data: z.infer<typeof LoginFormSchema>) => {
    await login(data);
  };

  const togglePersist = () => {
    console.log("Toggle persist called");
    setPersist((prev) => {
      console.log(prev);
      console.log(!prev);
      return !prev;
    });
  };

  useEffect(() => {
    localStorage.setItem("persist", JSON.stringify(persist));
    console.log(import.meta.env.VITE_DATABASE_URL);
  }, [persist]);

  return (
    <section className="w-full">
      <div className="h-screen flex items-center justify-center">
        <Card className="xl:w-1/4 md:w-1/2 shadow-md">
          <CardHeader className="w-full flex items-center text-3xl font-semibold">
            Login
          </CardHeader>
          <CardContent>
            {" "}
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(onSubmit)}
                className="space-y-8"
              >
                <div className="space-y-6">
                  <FormField
                    control={form.control}
                    name="email"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel className="text-base">Email</FormLabel>
                        <FormControl>
                          <Input
                            type="email"
                            placeholder="example@email.com"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="password"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel className="text-base">Password</FormLabel>
                        <FormControl>
                          <Input
                            type="password"
                            placeholder="*********"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <Button type="submit" size="full">
                  {" "}
                  Log in
                </Button>
                <div className="items-center flex space-x-2">
                  <Checkbox
                    id="persist"
                    checked={persist}
                    onCheckedChange={() => togglePersist()}
                  />{" "}
                  <Label htmlFor="persist">Keep me logged in</Label>
                </div>
              </form>
            </Form>
          </CardContent>
          <CardFooter>
            <Button
              variant="link"
              className="font-normal w-full"
              size="sm"
              asChild
            >
              <Link
                className="font-normal text-sm text-gray-500 no-underline"
                to="/"
              >
                Forgot password?
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>
  );
}

export default Login;
